import { Menu as e } from "../../design/menu/index.js";
import { Button as t } from "../../design/button/index.js";
import { cn as n } from "../../design/cn.js";
import { Check as r } from "lucide-react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { Portal as o } from "@ark-ui/react/portal";
// src/components/data-table/DataTableViewOptions.tsx
function s({ table: s, className: c, buttonClassName: l, buttonLabel: u = "View", menuLabel: d = "Toggle columns" }) {
	return /* @__PURE__ */ a(e.Root, { children: [/* @__PURE__ */ i(e.Trigger, {
		asChild: !0,
		children: /* @__PURE__ */ i(t, {
			variant: "secondary",
			size: "sm",
			className: n("ml-auto px-1.5 py-1", l),
			leftIcon: "Columns2",
			children: u
		})
	}), /* @__PURE__ */ i(o, { children: /* @__PURE__ */ i(e.Positioner, { children: /* @__PURE__ */ i(e.Content, {
		className: n("w-50", c),
		children: /* @__PURE__ */ a(e.Group, { children: [/* @__PURE__ */ i(e.Label, { children: d }), s.getAllColumns().filter((e) => e.accessorFn !== void 0 && e.getCanHide()).map((t) => /* @__PURE__ */ a(e.CheckboxItem, {
			value: t.id,
			checked: t.getIsVisible(),
			onCheckedChange: (e) => t.toggleVisibility(!!e),
			children: [/* @__PURE__ */ i(e.ItemText, {
				className: "capitalize",
				children: t.id
			}), /* @__PURE__ */ i(e.ItemIndicator, { children: /* @__PURE__ */ i(r, { className: "w-4 h-4" }) })]
		}, t.id))] })
	}) }) })] });
}
s.displayName = "DataTableViewOptions";
export { s as DataTableViewOptions };

//# sourceMappingURL=DataTableViewOptions.js.map